// extracted by mini-css-extract-plugin
export default {"definition":"Definition_definition__Ql-5d","definition__label":"Definition_definition__label__YAvn4","definition__value":"Definition_definition__value__zvsAX"};